import { createApp } from "vue";

import App from "./App.vue";

import "./assets/styles.scss";
import { installPlugins } from "./plugins";

// Enable mocking in development mode
const enableMocking = async () => {
  if (import.meta.env.VITE_MOCK_ENABLED === "true") {
    const { worker } = await import("./mocks/browser");
    worker.start();
  }
};

enableMocking().then(async () => {
  const app = createApp(App);

  await installPlugins(app);

  app.mount("#app");
});
